import Vue from 'vue'
import VueRouter from 'vue-router'
import PageNotFound from './pages/PageNotFound.vue'
import Home from './pages/Home.vue'
import ProductListPage from './pages/ProductListPage.vue'
import Profile from './pages/Profile.vue'
import PaymentSuccessPage from './pages/PaymentSuccessPage.vue'
import PaymentFaliPage from './pages/PaymentFaliPage.vue'
import TextPage from './pages/TextPage.vue'
import PayoutResultPage from './pages/PayoutResultPage.vue'



Vue.use(VueRouter)

export default new VueRouter({
	mode: 'history',
	routes: [
		//{ path: '/', redirect: '/home' },
		{
			path: '/',
			name: 'Home',
			component: Home
		},
		{
			path: '/product-list',
			name: 'ProductListPage',
			component: ProductListPage
		},
		{
			path: '/profile/:nav',
			name: 'Profile',
			component: Profile
		},
		{
			path: '/success-payout',
			name: 'PayoutSuccess',
			component: PayoutResultPage,
			props: { status: 'success' },
		},
		{
			path: '/fail-payout',
			name: 'PayoutFailure',
			component: PayoutResultPage,
			props: { status: 'failure' },
		},
		{
			path: '/pending-payout',
			name: 'PayoutPending',
			component: PayoutResultPage,
			props: (route) => ({ status: route.query.status || 'pending', message: route.query.message || '' }),
		},
		{
			path: '/success-payment',
			name: 'PaymentSuccessPage',
			component: PaymentSuccessPage
		},
		{
			path: '/fail-payment',
			name: 'PaymentFaliPage',
			component: PaymentFaliPage
		},
		{
			path: '/pages/:id',
			name: 'TextPage',
			component: TextPage
		},
		{ 
			path: "*", 
			name: 'PageNotFound',
			component: PageNotFound,
			props: {title: "PageNotFound"}
		}
	]
})
